export default __webpack_public_path__ + "static/media/9.cb4b4d99.svg";